<template>
<div class="box">
  <!-- 公共顶部1 -->
  <van-nav-bar title="多肉海淘群：bbtyy1127" >
  <!-- <template #right>
   <van-icon name="ellipsis" color="#FFFFFF" size="24"/>
  </template> -->
  </van-nav-bar>
  <!-- 搜索 -->
  <van-search
  v-model="params.keyWords"
  shape="round"
  show-action
  background="#BAB2D1"
  placeholder="微信名称或电话"
  >
    <template #action>
    <div class="search" @click="Search">查询</div>
    </template>
  </van-search>
  <div class="box_con">
    <div class="tab">
        <div class="tabs">
          <span class="item" :class="fkType===item.id?'item_av':''" @click="tabClick(item.id,'fk')" v-for="item in fkList" :key="item.id">{{item.name}}</span>
        </div>
        <div class="tabs">
          <span class="item" :class="fhType===item.id?'item_av':''" @click="tabClick(item.id,'fh')" v-for="item in fhList" :key="item.id">{{item.name}}</span>
        </div>
    </div>
    <div class="list">
      <div class="list_top">
        <div class="top_item">商品列表: <span style="color:#9A8EBA">{{orderCount||0}}</span> </div>
        <div class="top_item">应付金额: <span style="color:#9A8EBA">{{paid||0.00}}</span> </div>
         <div class="top_item">预付款: <span style="color:#9A8EBA">{{yfk||0.00}}</span> </div>
      </div>
      <div class="list_con" v-if="list">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="Load"
          >
            <div class="c_item" v-for="item in list" :key="item.id" @click="SHOW(item.id)">
            <img class="img" v-if="item.goodsImage" @error="errorImg(item)" :src="item.goodsImage" preview="0" alt="">
            <img class="img" v-if="!item.goodsImage" src="../../assets/bg.png" alt="">
            <div class="info">
              <div class="tit">{{item.goodsName}}
                <div class="status">
                  <span v-if="item.goodsStatus==0">未到货</span> 
                  <span v-if="item.goodsStatus==1">已到货</span> 
                  <span v-if="item.goodsStatus==2">已发货</span> 
                  <span v-if="item.goodsStatus==3">已收货</span> 
                  
                  <img src="../../assets/right.png" class="icon_r" alt="">
                </div>
              </div>
              <div class="time">{{item.createTime}}</div>
              <div class="num">
                ￥{{item.totalPayment}}
                <button class="btn" v-if="item.payStatus==0" @click="toPath(item)">付款</button>
                <button class="btn" v-if="item.payStatus==1&&item.goodsStatus==2" @click.stop="receipt(item)" >收货</button>
              </div>
            </div>
            <div class="detail" v-if="index==item.id">
              <div class="d_item"><div class="it_l">订单号</div><div class="it_r">{{item.orderNo}}</div></div>
              <div class="d_item"><div class="it_l">收货人</div><div class="it_r">{{item.receiverName}}</div></div>
              <div class="d_item"><div class="it_l">规格</div><div class="it_r">{{item.specifications}}</div></div>
              <div class="d_item"><div class="it_l">价格({{item.currencyName}})</div><div class="it_r">{{item.price}}</div></div>
              <div class="d_item"><div class="it_l">汇率</div><div class="it_r">{{item.exchangeRate}}</div></div>
              <div class="d_item"><div class="it_l">运费</div><div class="it_r">{{item.freight}}</div></div>
              <div class="d_item"><div class="it_l">付款情况</div><div class="it_r">{{item.payStatus==0?' 未付款':'已付款'}}</div></div>
              <div class="d_item"><div class="it_l">备注</div><div class="it_r">{{item.remarks?item.remarks:'无'}}</div></div>
              <div class="d_item" v-if="item.expressCompany"><div class="it_l">快递公司</div><div class="it_r">{{item.expressCompany?item.expressCompany:'无'}}</div></div>
              <div class="d_item" v-if="item.oddNum"><div class="it_l">快递单号</div><div class="it_r">{{item.oddNum?item.oddNum:'无'}}</div></div>
              <div class="d_item"  style="margin:0">物流情况  &nbsp;&nbsp;&nbsp; <span style="color: #666666;font-size:14px">未设置物流信息，或物流信息不全</span></div>
            </div>
          </div>
          </van-list>
     
      </div>
    </div>
  </div>
  <div class="statement">
    <div class="s_tit">免责声明</div>
    <div class="s_con">查询结果仅代表使用者的工作记,其销售关系与本公司无关</div>
    <div class="s_con">Copyright @ 2016-2021 bbtyy1127.cn</div>
  </div>
</div>
</template>
<script>
import {getList,Receive} from '@/api/login'
export default {
  data () {
    return {
      // 控制折叠
      index:'',
      // 搜索
      value: '',
      orderCount:0,
      paid:0.00,
      yfk:0.00,
      // 状态
      fkType:'',
      fhType:'',
      fkList:[
        {id:'',name:'全部'},
        {id:1,name:'已付款'},
        {id:0,name:'未付款'},
      ],
      fhList:[
        {id:'',name:'全部'},
        {id:0,name:'未到货'},
        {id:1,name:'已到货'},
        {id:2,name:'已发货'},
        {id:3,name:'已收货'},
      ],
      list:[],
      obj: {},
      loading: false,
      finished: true,
      params:{
        pageNum:1,
        pageSize:10,
        keyWords:'',
        goodsStatus:'',
        payStatus:''
      },
      total:''
    }
  },
  created(){
    this.params.keyWords=''
    this.params.pageNum=1
    this.list=[]
  },
  methods: {
      errorImg(index) {
      this.list.forEach(i => {
        if (i.id == index.id) {
          i.goodsImage = ''
        }
      })
      this.$previewRefresh()
    },
    receipt(obj){
       this.$dialog.alert({
          title: '确认收货',
          message: '是否确认该货品收货',
          theme: 'round-button',
          }).then(() => {
            this.obj=obj
            this.obj.goodsStatus=3
               delete this.obj.createTime
               delete this.obj.updateTime
                delete this.obj.payTime
                 delete this.obj.arrivalTime
                 delete this.obj.sendTime
                   delete this.obj.receivingTime
                Receive(this.obj).then(res=>{
                if(res.code==0){
                  this.$toast.success('确认收货,前台状态稍后更新')
                  this.Search()
                }else{
                   this.$toast.fail('确认收货失败')
                }
              })
          });
        
    },
    Search(){
      this.params.pageNum=1
       this.list=[]
       this.orderCount=0
       this.paid=0.00
        this.yfk=0.00
       this.Load()
    },
    Load() {
      // 异步更新数据
     getList(this.params).then(res => {
       this.total=res.data.total
       this.paid=res.data.paid
       this.orderCount=res.data.orderCount
       this.yfk=res.data.money
       if(!res.data.orders){
          this.finished = true;
         return
       }
    //进行判断
	    if(this.total <= this.params.pageSize){
		    this.list = res.data.orders
	    }else{
		    this.params.pageNum++;
		    let arr =res.data.orders;
		    this.list = this.list.concat(arr);
	    };
	    // 加载状态结束
	    this.loading = false;
	    // 数据全部加载完成
       this.$previewRefresh()
	    if (this.list.length >= this.total) {
		    this.finished = true;//结束，显示我也是有底线的
	     }else{
           this.finished = false;
       }
      })
    },
    // 选择状态
    tabClick(id,type){
      if(type=='fk'){
        this.fkType=id
        this.params.payStatus=id
      }else{
        this.fhType=id
        this.params.goodsStatus=id
      }
      this.params.pageNum=1
      this.list=[]
       this.orderCount=0
       this.paid=0.00
         this.yfk=0.00
       this.Load()
    },
    // 控制显示
    SHOW(index){
      console.log(this.index==index)
      if(index==this.index){
        this.index=''
        return
      }
      this.index=index
    },
    toPath(item){
      this.$router.push('/list?goodsName='+item.goodsName+'&totalPayment='+item.totalPayment+'&orderNo='+item.orderNo)
    }
  }
}
</script>
<style scoped lang='less'>
.icon_r{
  width: 8px;
  height: 14px;
}
.item_av{
  color: #FFFFFF !important;
  border-radius: 12px;
  background: #8A88C9 !important;
}
.box{
  width: 100%;
  height: 100vh;
  background-color: #BAB2D1;
  padding-top: 47px;
  position: relative;
  box-sizing: border-box;
  .box_con{
    width: 100%;
    padding: 0px 12px;
    box-sizing: border-box;
    .tab{
      width: 100%;
      padding: 6px 12px;
      box-sizing: border-box;
      border-radius: 10px;
      background-color: #fff;
      .tabs{
        width: 100%;
        height: 40px;
        line-height: 25px;
        .item{
          display: inline-block;
          padding: 1px 8px;
          box-sizing: border-box;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
        }

      }
    }
    .list{
      width: 100%;
      margin-top: 16px;
      background-color: #fff;
      border-radius: 10px;
      height: calc(100vh - 300px);
      .list_top{
        width: 100%;
        padding: .3125rem .625rem .3125rem .625rem;
        box-sizing: border-box;
        border-bottom: 1px solid #B8AFCE;
       .top_item{
         display: inline-block;
         width: 100%;
        height: .8rem; 
        line-height: .8rem;
          text-align: left;
         font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
       }
      }
      .list_con{
        width: 100%;
        height: calc(100% - 4.3rem);
        overflow-y:scroll;
        .c_item{
          width: 100%;
          padding: 18px ;
          box-sizing: border-box;
          border-bottom: 1px solid #B8AFCE;
          .img{
            width:100px;
            height: 100px;
            vertical-align: middle;
            margin-right: 10px;
          }
          .info{
            display: inline-block;
            vertical-align: top;
            width: calc(100% - 110px);
            .tit{
              color: #4F6EAF;
              line-height: 20px;
              font-size: 20px;
              overflow: hidden;
              .status{
                float: right;
                line-height: 20px;
                font-size: 16px;
                color: #B8AFCE;
              }
            }
            .time{
              font-size: 14px;
              font-weight: 300;
              margin: 12px auto;
              color: #333333;
            }
            .num{
              font-size: 24px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #FF0000;
              .btn{
                float:right;
               width: 60px;
                height: 35px;
                background: #8A88C9;
                border-radius: 10px;  
                border: 0;
                color: #FFFFFF;
                font-size: 16px;
              }
            }
          }
          .detail{
            width: 100%;
            margin-top: 15px;
            .d_item{
              width: 100%;
              margin-bottom: 8px;
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #333333;
              .it_l{
                display: inline-block;
                vertical-align: top;
                width: 30%;
              }
              .it_r{
                display: inline-block;
                width: 70%;
                text-align: right;
              }
            }
          }
        }
      }
      .list_con::-webkit-scrollbar {
        display: none;
      }
    }
  }
  .statement{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 16px;
    box-sizing: border-box;
    text-align: center;
    color: #FFFFFF;
    .s_tit{
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .s_con{
      font-size: 12px;
      font-size: 500;
    }
  }
  /deep/.van-search__content{
    padding-left: 16px !important;
  }
  /deep/.van-nav-bar{
    height: 46px;
    background-color: #BAB2D1;
  }
  /deep/.van-nav-bar__title{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
  .search{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
}
/deep/.van-icon-search{
  color: #BAB2D1;
  font-size: 24PX;
}
</style>
